import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import classNames from 'classnames';

class CustomModal extends Component {
  static propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    color: PropTypes.string.isRequired,
    colored: PropTypes.bool,
    header: PropTypes.bool,
    onAccept: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    okButtonText: PropTypes.string,
    cancelButtonText: PropTypes.string
  };

  static defaultProps = {
    title: '',
    message: '',
    colored: false,
    header: false,
    okButtonText: "Ok",
    cancelButtonText: 'Cancel'
  };

  render() {
    const {
      color, title, message, colored, header, onAccept, isOpen, onClose, okButtonText, cancelButtonText
    } = this.props;
    let Icon;

    switch (color) {
      case 'primary':
        Icon = <span className="lnr lnr-pushpin modal__title-icon" />;
        break;
      case 'success':
        Icon = <span className="lnr lnr-thumbs-up modal__title-icon" />;
        break;
      case 'warning':
        Icon = <span className="lnr lnr-flag modal__title-icon" />;
        break;
      case 'danger':
        Icon = <span className="lnr lnr-cross-circle modal__title-icon" />;
        break;
      default:
        break;
    }
    const modalClass = classNames({
      'modal-dialog--colored': colored,
      'modal-dialog--header': header,
    });

    return (
      <div>
        <Modal
          isOpen={isOpen}
          toggle={this.toggle}
          className={`modal-dialog--${color} ${modalClass}`}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={this.toggle} />
            {header ? '' : Icon}
            <h4 className="bold-text  modal__title">{title}</h4>
          </div>
          <div className="modal__body">
            {message}
          </div>
          <ButtonToolbar className="modal__footer">
            <Button onClick={onClose}>{ cancelButtonText }</Button>{' '}
            <Button outline={colored} color={color} onClick={onAccept}>{ okButtonText }</Button>
          </ButtonToolbar>
        </Modal>
      </div>
    );
  }
}

export default CustomModal;
